import ServiceCategoryPage from "../components/ServiceCategoryPage";
import cookChefService from "../data/services/cookChefService";

function CookChef() {
  return <ServiceCategoryPage service={cookChefService} />;
}

export default CookChef;